import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AuthService} from '../services/auth.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const userToken = this.authService.getUserToken();
    if (userToken) {
      request = request.clone({
        setHeaders: {
          Authorization: `${userToken}`,
          'Content-Type': 'application/json'
        }
      });
    }

    return next.handle(request);
  }
}
